import { BehaviorSubject } from 'rxjs'
import { first } from 'rxjs/operators'
import { RxJS } from './RxJS'
import { RxJSStateDefinable } from '../Types/Types'

const disabledFlagsSubject: BehaviorSubject<Definable<Record<string, Definable<boolean>>>> = new BehaviorSubject<
    Definable<Record<string, Definable<boolean>>>
>(undefined)

RxJS.disabledFlags = RxJS.disabledFlags ?? {
    subject: disabledFlagsSubject,
    observable: disabledFlagsSubject.asObservable(),
    announce: (data?: Record<string, Definable<boolean>>): void => {
        disabledFlagsSubject
            .pipe(first())
            .subscribe((disabledFlags: Definable<Record<string, Definable<boolean>>>) =>
                disabledFlagsSubject.next({ ...disabledFlags, ...data })
            )
    }
}

export const disabledFlags$: RxJSStateDefinable<Record<string, Definable<boolean>>> = RxJS.disabledFlags
